import img1 from "./images/illustration/instagram-img-1.jpg";
import img2 from "./images/illustration/instagram-img-2.jpg";
import img3 from "./images/illustration/instagram-img-3.jpg";
import img4 from "./images/illustration/instagram-img-4.jpg";




const Instagram=()=>{
    return(
        <>
        <section className=" container-fluid" id="demo7">
                        <section className="container mt-3">
                            <section className="row pb-3 pt-3">
                                <div className="col-12">
                                    <h2>SUBSCRIBE TO OUR INSTAGRAM</h2>
                                </div>
                                <div className="col-xl-3 col-12 col-md-6 mt-5">
                                    <img src={img1} alt="image not found"
                                        className="img-fluid"/>
                                </div>
                                <div className="col-xl-3 col-12 col-md-6 mt-5">
                                    <img src={img2} alt="image not found"
                                        className="img-fluid"/>
                                </div>
                                <div className="col-xl-3 col-12 col-md-6 mt-5">
                                    <img src={img3} alt="image not found"
                                        className="img-fluid"/>
                                </div>
                                <div className="col-xl-3 col-12 col-md-6 mt-5">
                                    <img src={img4} alt="image not found"
                                        className="img-fluid"/>
                                </div>
                            </section>
                        </section>
                    </section>
        </>

    );
}

export default Instagram;